import { flowCopy } from "../../utils/flowCopy";
import useMountedRef from "../../utils/useMountedRef";
import React, { useState, useRef } from "react";
import localizationStrings from "../../statics/localization";
import Notification from "../notification";
import { setUserLanguage } from "../../api/user/user";
import { useHistory } from "react-router-dom";
import { setCookieApiCall } from "../../api/config/configApi";
import ReturnIcon from "../../assets/icons/svg/ReturnIcon";
import AtlasLogo from "../../assets/logo/atlas-logo.png";
import UnselectIcon from "../../assets/icons/svg/UnselectIcon";
import SelectedIcon from "../../assets/icons/svg/SelectedIcon";
import ParentalSelectingIcon from "../../assets/icons/svg/ParentalSelectingIcon";

const Language = () => {
  const [showNotification, setShowNotification] = useState(false);
  const mounted = useMountedRef();
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const [selectedLang, setSelectedLang] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);

  let languages = [
    { code: "arb", title: "Arabic", display: "العربية" },
    { code: "eng", title: "English", display: localizationStrings.english }
  ];
  if (process.env.REACT_APP_ENGLISH_PRESENTATION === "true" && process.env.REACT_APP_ARABIC_UI !== "true")
    languages = languages.filter((item) => item.code === "eng" || (item.code === "arb" && process.env.REACT_APP_ARABIC_UI === "true"));
  let history = useHistory();

  const clickConfirm = async () => {
    if (pending.current || !selectedLang.code) return;
    const profile = localStorage.getItem("profile");
    const token = localStorage.getItem("userToken");
    const isCurrent = () => mounted.current && localStorage.getItem("profile") === profile && localStorage.getItem("userToken") === token;
    pending.current = true; setBusy(true); setError(false); setShowNotification(false);
    try {
      await setUserLanguage(null, null, selectedLang.title);
      if (!isCurrent()) return;
      // Only legacy sessions use the SDK cookie endpoint.
      if (localStorage.getItem("interfaceurl")) await setCookieApiCall("language", selectedLang.code, false);
      if (!isCurrent()) return;
      localStorage.setItem("language", selectedLang.code);
      localizationStrings.setLanguage(selectedLang.code);
      window.location.reload();
    } catch (e) { if (mounted.current) setError(true); }
    finally { pending.current = false; if (mounted.current) setBusy(false); }
  };

  const clickNotConfirm = () => {
    setShowNotification(false);
    setSelectedLang({});
    setSelectedOption(null);
  };

  const onChangeLanguage = (item) => {
    setShowNotification(true);
    setSelectedLang(item);
    setSelectedOption(item.code);
  };

  const renderedItems = languages.map((item) => {
    let iconEl;
    if (selectedOption === item.code) {
      iconEl = <ParentalSelectingIcon />;
    } else if (localizationStrings.getLanguage() === item.code) {
      iconEl = <SelectedIcon />;
    } else {
      iconEl = <UnselectIcon />;
    }

    return (
      <button
        type="button"
        aria-pressed={
          (selectedOption || localizationStrings.getLanguage()) === item.code
        }
        disabled={busy}
        key={item.code}
        onClick={() =>
          localizationStrings.getLanguage() !== item?.code
            ? onChangeLanguage(item)
            : null
        }
        className="parentalcontrol-card-wrapper"
      >
        <div className="parentalcontrol-card">
          <div className="pc-card-body">
            <div className="pc-card-selector">{iconEl}</div>
            <div className="pc-card-texts">
              <div className="pc-card-title">{item?.display}</div>
            </div>
          </div>
        </div>
      </button>
    );
  });

  return (
    <div className="settings-container">
      <div
        className="settings-icon"
        style={{
          position: "fixed",
          insetInlineStart: `${(33 / 1920) * 100}vw`,
          top: `calc(${(72 / 1920) * 100}vw + ${(49 / 1920) * 100}vw)`,
          zIndex: 5,
          margin: 0,
          gap: "10px"
        }}
        onClick={() => {
          history.push(`/dashboard/settings`);
        }}
      >
        <ReturnIcon />
        <div className="icon-settings">{localizationStrings.back}</div>
      </div>
      <div className="pc-header">
        <img className="pc-logo" src={AtlasLogo} alt="Atlas" />
        <div className="pc-title">{localizationStrings.menuLanguage}</div>
      </div>
      {error && <p role="alert">{flowCopy().error}</p>}
      <div className="parental-control-container">{renderedItems}</div>
      {showNotification ? (
        <Notification
          text={localizationStrings.changeLangText}
          confirmText={localizationStrings.yes}
          notConfirmText={localizationStrings.no}
          theme="dark"
          onClickConfirm={clickConfirm}
          onClickNotConfirm={clickNotConfirm}
        />
      ) : null}
    </div>
  );
};

export default Language;
